"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.projection", ["nucont.shared"]);
require("./projection.routes");
